// Module
var code = `<div class="center-picker">

  <div>
    <input
      type="text"
      placeholder="Lookup centers by name"
      ng-model="\$ctrl.name"
      ng-keydown="\$event.which === 13 && \$ctrl.search()"
      autocomplete="off"
      class="lookup-input"
    />
    <button class="btn btn-primary search-btn" type="button" ng-click="\$ctrl.search()" ng-disabled="!\$ctrl.enableSearch()">
      Search
    </button>
    <button class="btn clear-btn" type="button" ng-click="\$ctrl.clear()" ng-if="\$ctrl.visible">
      Clear
    </button>
  </div>

  <div class="content" ng-if="\$ctrl.visible">
    <table ng-if="\$ctrl.searchResults.length > 0" class="table">
      <thead>
      <tr>
        <th>Name</th>
        <th>Reference no.</th>
        <th>Branch</th>
        <th>Loan officer</th>
        <th>Loan collector</th>
        <th>Status</th>
        <th>&nbsp;</th>
      </tr>
      </thead>

      <tbody>
      <tr ng-repeat="result in \$ctrl.searchResults">
        <td>{{result.name}}</td>
        <td>{{result.id}}</td>
        <td>{{\$ctrl.getBranchName(result.branchId)}}</td>
        <td>{{\$ctrl.users[result.loanOfficerId].effectiveName}}</td>
        <td>{{\$ctrl.users[result.loanCollectorId].effectiveName}}</td>
        <td>{{result.active ? 'Active' : 'Inactive'}}</td>
        <td>
          <button type="button" ng-click="\$ctrl.choose(result, \$event)" class="btn btn-primary"
                  ng-disabled="!result.active">
            {{\$ctrl.buttonLabel || 'Choose'}}
          </button>
        </td>
      </tr>
      </tbody>
    </table>

    <div class="no-results" ng-if="\$ctrl.searchResults.length === 0">
      No centers have been found.
    </div>

  </div>
</div>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/common/center-picker/center-picker.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;